import { Tolgee, DevTools, BackendFetch } from '@tolgee/react';
import { FormatIcu } from '@tolgee/format-icu';

/**
 * Instancia preconfigurada de Tolgee para importación directa
 * Esta variable se exporta para ser utilizada directamente en los componentes
 */
export const tolgeeConfig = {
  apiUrl: 'https://translations.vallegalbarro.beeapp.es',
  apiKey: 'tgpak_gjpxgm3dnjxgk5lton3g2n3hmrxgk3twnjtheztcgntws',
  projectId: 2, // Como número, no string
  language: 'es',
  fallbackLanguage: 'es',
};

/**
 * Inicializa y retorna una instancia de Tolgee configurada para la aplicación
 *
 * @returns Instancia de Tolgee configurada
 */
export const getTolgeeInstance = () => {
  return Tolgee()
    .use(DevTools())
    .use(FormatIcu())
    .use(BackendFetch()) // Plugin para cargar traducciones desde el servidor
    .init({
      // Configuración del servidor Tolgee
      apiUrl: tolgeeConfig.apiUrl,
      apiKey: tolgeeConfig.apiKey,
      projectId: tolgeeConfig.projectId,

      // Idioma inicial y fallback
      language: tolgeeConfig.language,
      fallbackLanguage: tolgeeConfig.fallbackLanguage,

      // Idiomas disponibles en la aplicación
      availableLanguages: ['es', 'en', 'ar'],

      // Namespace por defecto

      // Cargar las traducciones de forma eager (inmediata)
      observerType: 'text',
      observerOptions: {
        fullKeyEncode: false
      }
    });
}; 